import { createFileRoute } from "@tanstack/react-router";
import { type FC, useCallback, useEffect } from "react";
import { z } from "zod";
import { FullScreenLoading } from "../../../../../components/molecules/FullScreenLoading";

const fallback = "/" as const;

const RedirectRails: FC = () => {
  const search = Route.useSearch();

  const redirectToRoot = useCallback(async () => {
    const redirectUrl = search.redirect_uri;
    if (redirectUrl) {
      window.location.href = redirectUrl;
    } else {
      window.location.href = window.origin || fallback;
    }
  }, [search]);

  useEffect(() => {
    redirectToRoot();
  }, [redirectToRoot]);

  return <FullScreenLoading />;
};

// biome-ignore assist/source/useSortedKeys: ordering required for type inference, waiting a TanStack Biome plugin
export const Route = createFileRoute("/_private/redirect/rails/home/")({
  validateSearch: z.object({
    redirect_uri: z.optional(z.string()).catch(""),
  }),
  component: RedirectRails,
});
